@if (ready) {
  <div class="modalSuccess">
      <div>
        <h4 class="titleModalAgency">{{ title }}</h4>
      </div>
      @if (message) {
          {{ message }}
      }
      <div class="my-button-container">
        <button class="my-button confirm" mat-raised-button (click)="close()">{{ closeLabel }}</button>
      </div>
  </div>
}
